export const OPEN_SUCCESS_SNACKBAR = 'OPEN_SUCCESS_SNACKBAR';
export const OPEN_ERROR_SNACKBAR = 'OPEN_ERROR_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';